import * as React from 'react';
import { Button, Modal, Container, Textarea } from '../../../Components';
import styled from 'styled-components';
import { ValidationError } from '../../../Store';

interface IModalProps {
  isOpen: boolean;
  outterClick: (() => void);
  onTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  texto: string;
  reprovar: () => void;
  errors: ValidationError<{ justificativaReprovacao: string }>;
}

const StyledModal = styled(Modal)`
    font-family: Roboto,sans-seriff;
    height: fit-content;
    min-height: 200px;
`;

const ContainerGrid = styled(Container)`
  grid-template-columns: repeat(12, 1fr);
  padding-left: 30px;
`;

const StyledTitle = styled.span`
    font-size: 20px;
    padding: 10px 0px 0px 0px;
    font-weight: 500;
    grid-column: 1/12;
`;

const StyledSubTitle = styled.span`
    color: gray;
    font-size: 13px;
    padding: 5px 0px 5px 0px;
    grid-column: 1/12;
`;
const TextareaGrid = styled(Textarea)`
    background-color: transparent;
    margin: 0;
    margin-right: 15px;
    grid-column: 1/12;
`;

const StyledButton = styled(Button)`
    grid-column: 9/11;
    justify-self: flex-end;

    @media (max-width: 640px) {      
      grid-column: 1/12;
      justify-self: center;
    }
`;

const StyledButtonSair = styled(Button)`
    grid-column: 11/12;
    justify-self: flex-start;
    
    @media (max-width: 640px) {      
      grid-column: 1/12;
      justify-self: center;
    }
`;

const JustificativaDaReprovacaoModalPP: React.FC<IModalProps> = (props: IModalProps) => {
  const { isOpen, outterClick, texto, onTextChange, reprovar, errors } = props;

  return (
    <StyledModal
      size='medium'
      outterClick={outterClick}
      isVisible={isOpen}
    >
      <ContainerGrid>
        <StyledTitle>Orientação não aceita</StyledTitle>
        <StyledSubTitle>Ao não aceitar esta indicação de orientação, o pré-projeto será encaminhado a outro docente também indicado pelo Aluno</StyledSubTitle>
        <StyledSubTitle>Professor, informe o motivo da não aceitação, de acordo com o seu critério próprio de seleção de orientandos.</StyledSubTitle>
        <TextareaGrid
          label='Justificativa'
          name='justificativaReprovacao'
          value={texto}
          onChange={onTextChange}
          color={
            errors && errors.justificativaReprovacao != undefined ? 'errorColor'
              : 'secondaryLightColor'}
          gridColumn='1/12'
          hasError={errors && errors.justificativaReprovacao != undefined}
          errorMessage={errors && errors.justificativaReprovacao}
        />
        <StyledButton
          type='submit'
          color='errorColor'
          onClick={reprovar}
        >
          CONFIRMAR
        </StyledButton>
        <StyledButtonSair
          onClick={outterClick}
        >
          SAIR
        </StyledButtonSair>
      </ContainerGrid>
    </StyledModal>
  );
};

export default JustificativaDaReprovacaoModalPP;
